module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.dcbc89c9.svg";